import { useState } from "react";

export const useMultistepForm = (steps) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [formHeaderText] = useState([
    "Patient Information",
    "Test / Profile Selection",
    "Billing Information",
    "Order Summary",
  ]);

  const handleNext = () => {
    setCurrentStepIndex((prevIndex) => {
      if (prevIndex >= steps.length - 1) {
        return prevIndex;
      }
      return prevIndex + 1;
    });
  };

  const handlePrev = () => {
    setCurrentStepIndex((prevIndex) => {
      if (prevIndex <= 0) {
        return prevIndex;
      }
      return prevIndex - 1;
    });
  };

  return {
    currentStepIndex,
    handleNext,
    handlePrev,
    isFirstStep: currentStepIndex === 0,
    isLastStep: currentStepIndex === steps.length - 1,
    steps,
    step: steps[currentStepIndex],
    formHeaderText: formHeaderText[currentStepIndex],
    progressText: formHeaderText,
    setCurrentStepIndex,
  };
};
